import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";
import { HoverHintContent, HoverHintTrigger } from "@/components/ui/title-help";
import { MrpIncomingPeekHoverHintBody } from "@/components/mrp/MrpIncomingPeekHoverHintBody";
import { buildMrpIncomingPartsPath } from "@/lib/mrp";

import {
  formatTransferOriginOnHand,
  originOnHandExceedsQuantity,
} from "./transfersOriginInventoryModel";

export function TransferOriginOnHandHeader({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <th className={className}>
      <span className="inline-flex justify-end">
        <HoverHintContent hoverHint="On hand">
          <span>Origin</span>
        </HoverHintContent>
      </span>
    </th>
  );
}

export function TransferOriginOnHandCell({
  value,
  loading = false,
  siteMissing = false,
  compareQuantity,
  className,
  sku,
  originSiteCode,
}: {
  value: number | null;
  loading?: boolean;
  siteMissing?: boolean;
  /** When set, highlight amber if this quantity exceeds origin on-hand. */
  compareQuantity?: number;
  className?: string;
  sku?: string | null;
  originSiteCode?: string | null;
}): JSX.Element {
  const exceeds =
    compareQuantity != null && Number.isFinite(compareQuantity)
      ? originOnHandExceedsQuantity(value, compareQuantity)
      : false;
  const trimmedSku = sku?.trim() ?? "";
  const siteCode = originSiteCode?.trim().toLowerCase() ?? "";
  const incomingHref =
    trimmedSku !== "" && siteCode !== "" && !siteMissing && !loading
      ? buildMrpIncomingPartsPath({ cpn: trimmedSku, location: siteCode })
      : null;
  const display = formatTransferOriginOnHand(value, { loading, siteMissing });

  return (
    <td
      className={cn(
        "text-right",
        exceeds ? "font-medium text-amber-700" : "text-slate-700",
        className,
      )}
    >
      {incomingHref != null ? (
        <HoverHintTrigger
          align="end"
          closeOnTriggerActivate
          className="justify-end"
          trigger={
            <Link
              to={incomingHref}
              className={cn(
                "tabular-nums underline underline-offset-2",
                exceeds
                  ? "font-medium text-amber-700 decoration-amber-400 hover:text-amber-900"
                  : "text-sky-800 decoration-sky-300 hover:text-sky-950",
              )}
              onClick={(event) => event.stopPropagation()}
              onPointerDown={(event) => event.stopPropagation()}
            >
              {display}
            </Link>
          }
        >
          <MrpIncomingPeekHoverHintBody cpn={trimmedSku} location={siteCode} />
        </HoverHintTrigger>
      ) : (
        display
      )}
    </td>
  );
}
